import { render } from "./StageField.vue?vue&type=template&id=51f6967c&scoped=true"
import script from "./StageField.vue?vue&type=script&lang=js"
export * from "./StageField.vue?vue&type=script&lang=js"

import "./StageField.vue?vue&type=style&index=0&id=51f6967c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f6967c"]])

export default __exports__